import * as tslib_1 from "tslib";
import * as markRead from 'owa-mail-mark-read-actions';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import getLatestNonDraftItemIdFromConversation from 'owa-mail-message-actions/lib/utils/getLatestNonDraftItemIdFromConversation';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import resetSelectionInternal from './resetSelectionInternal';
import setFocusedRowKey from './mutators/setFocusedRowKey';
import setSelectionAnchorRowKey from './mutators/setSelectionAnchorRowKey';
import setMultiSelectionAnchorRowKey from './mutators/setMultiSelectionAnchorRowKey';
import { action } from 'satcheljs/lib/legacy';
import { is3SFeatureEnabled, isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyAddPopout, PopoutType } from 'owa-popout-store';
import { lazyMoveReadingPaneToTab } from 'owa-mail-reading-pane-store';
import { setSelectionOnRow } from 'owa-mail-actions/lib/mailListSelectionActions';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { preparePopoutDataForReadingPane } from 'owa-mail-reading-pane-view';
// Bug 32656: In an orchestrator, the render is triggered several times
// Due to this bug, ReadingPane.render() is triggered several times inside this method.
// To solve the reading pane perf issue, wrap this function as an action.
// When the bug is resolve, please remove the action wrapper.
/**
 * Single select mail row
 * @param tableView where the operation is being performed
 * @param rowKey the rowKey of the item to select
 * @param isUserNavigation whether user's click or action triggered this action
 * @param mailListItemSelectionSource The source of selection on mail item
 */
export default action('singleSelectRowInternal')(function singleSelectRowInternal(tableView, rowKey, isUserNavigation, mailListItemSelectionSource) {
    // Open popout if user is double clicking item regardless of selection state
    if (mailListItemSelectionSource == MailListItemSelectionSource.MailListItemBodyDoubleClick) {
        var rowKey_1 = tslib_1.__spread(tableView.selectedRowKeys.keys())[0];
        openRowInPopout(rowKey_1, tableView);
        return;
    }
    // When user tries to single select a row
    if (tableView.selectedRowKeys.size == 1) {
        if (tableView.selectedRowKeys.has(rowKey)) {
            // Do nothing if user is selecting the same item unless user clicks body or presses ENTER in SLV
            // or if user clicks mail item preview
            if (!(getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
                ReadingPanePosition.Off &&
                (mailListItemSelectionSource == MailListItemSelectionSource.KeyboardEnter ||
                    mailListItemSelectionSource ==
                        MailListItemSelectionSource.MailListItemBody ||
                    mailListItemSelectionSource ==
                        MailListItemSelectionSource.MailListItemRichPreview))) {
                return;
            }
        }
        // Before reseting selection, need to mark the previously selected row as read
        var oldSelectedRowKey = tslib_1.__spread(tableView.selectedRowKeys.keys())[0];
        markRead.lazyOnSingleSelectionChanged.importAndExecute(oldSelectedRowKey, tableView, isUserNavigation);
    }
    else if (mailListItemSelectionSource == MailListItemSelectionSource.SearchSuggestionClick &&
        is3SFeatureEnabled('sea-emailSuggestionsInTab')) {
        // open search email suggestion in a tab
        openRowInTab(rowKey, tableView);
        return;
    }
    // Reset list view selection
    resetSelectionInternal(tableView);
    setFocusedRowKey(tableView, rowKey);
    // Set the selection anchor for possible future range, keyboard, or multi selections
    if (isMailFeatureEnabled('tri-selectionRefactor')) {
        setSelectionAnchorRowKey(tableView, rowKey);
        setMultiSelectionAnchorRowKey(tableView, null);
    }
    // Select new item
    setSelectionOnRow(rowKey, tableView.id, true /* shouldSelect */);
});
function openRowInTab(rowKey, tableView) {
    var instrumentationContext = getInstrumentationContextsFromTableView([rowKey], tableView)[0];
    var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
    var rowSubject = MailRowDataPropertyGetter.getSubject(rowKey, tableView);
    var rowCategories = MailRowDataPropertyGetter.getCategories(rowKey, tableView);
    lazyMoveReadingPaneToTab.importAndExecute(rowId, rowSubject, rowCategories, true /* makeActive */, instrumentationContext);
}
function openRowInPopout(rowKey, tableView) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rowId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMailFeatureEnabled('rp-popouts')) return [3 /*break*/, 3];
                    rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
                    if (!(tableView.tableQuery.listViewType == 0 /* Conversation */)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getLatestNonDraftItemIdFromConversation(rowId)];
                case 1:
                    rowId = _a.sent();
                    _a.label = 2;
                case 2:
                    // Ensure we have a valid rowId in case the GCI call failed.
                    if (rowId) {
                        preparePopoutDataForReadingPane(tableView);
                        lazyAddPopout.importAndExecute(PopoutType.ReadingPane, rowId.Id, null /* AddPopoutSource */, rowId.mailboxInfo);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=singleSelectRowInternal.js.map